export default __webpack_public_path__ + "static/media/1_0128.056292ec.webp";